<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Change Standard Learner Division </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row dense justify="center" class="no-display">
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        rounded
                        dense
                        required
                        v-model="current_academic_year"
                        :items="academic_year_list"
                        item-text="ay"
                        item-value="id"
                        label="Academic Year"
                        outlined
                        persistent-hint
                        hint="Please Select Academic Year"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete rounded dense required v-model="std" :items="standard_list" item-text="standard" item-value="id" label="Standard" outlined persistent-hint hint="Please Select Standard"></v-autocomplete>
                </v-col>
                <v-col cols="12" md="3" sm="3">
                    <v-btn rounded class="button mt-6" v-if="std && current_academic_year" @click="getStdStudent()" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <col />
            <v-col cols="12" md="12" sm="12" v-if="studentinfo!=''">
                <v-row class="box" justify="center" dense v-if="this.selected!=''">
                    <v-col cols="12" md="2" sm="2" class="pt-5 mt-5">
                        <strong>Total Selected - {{ selected.length }}</strong>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                        <v-icon color="error">*</v-icon>
                        <v-autocomplete rounded dense required v-model="div" :items="division_list" item-text="division" item-value="id" label="Division" outlined persistent-hint hint="Please Select Division"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3" sm="3">
                        <v-btn rounded class="button mt-6" v-if="div" @click="changeDivision()" :loading="loader">Change Division</v-btn>
                    </v-col>
                </v-row>
                <v-data-table :headers="headers_students" :items="bookList1" @current-items="getFiltered" :items-per-page="-1" :search="search" class="elevation-1 mytable" dense show-select v-model="selected" item-key="ldiv">
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers_students" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete
                                                        class="mr-2 pb-5 pt-2"
                                                        flat
                                                        hide-details
                                                        small
                                                        rounded
                                                        dense
                                                        outlined
                                                        color="#0F2027"
                                                        :label="header.text"
                                                        multiple
                                                        clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"
                                                    ></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
            </v-col>
        </v-card>
         <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                loader: false,
                color: "",
                snackbar: false,
                search: "",
                snackbar_msg: null,
                overlay:false,
                current_academic_year: null,
                std: "",
                header: null,
                academic_year_list: null,
                standard_list: null,
                studentinfo: [],
                selected: [],
                filterArr: [],
                filters: {
                    division: [],
                    registration_number: [],
                },
                headers_students: [
                    { text: "Sr. No.", value: "count" },
                    { text: "Roll Number", value: "rollnumber" },
                    { text: "Student Name", value: "studentname" },
                    { text: "Registration Number", value: "registration_number" },
                    { text: "Division", value: "division" },
                ],
                division_list: [],
                div: null,
            };
        },
        computed: {
            bookList1() {
                return this.studentinfo.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.studentinfo.map((d) => d[val]);
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/Admission/getInitialData")
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.academic_year_list = res.data.ay_list;
                            this.standard_list = res.data.standard_list;
                        } else {
                            //error
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //close loader
                        this.get_ay_std_ft_loader = false;
                    });
            },
            // markAllSelected() {
            //     this.selected = [];
            //     for (let i = 0; i < this.studentinfo.length; i++) {
            //         this.selected.push(this.studentinfo[i]);
            //     }
            // },
            async changeDivision() {
                const formdata = {
                    selected: this.selected,
                    div: this.div,
                };
            },
            async getStdStudent() {
                const formdata = {
                    ay: this.current_academic_year,
                    std: this.std,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Admission/getStdStudent", formdata);
                    if (res.data.flag == "YES") {
                        this.studentinfo = res.data.studentinfo;
                        this.division_list = res.data.division_list;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                   // this.markAllSelected();
                }
            },
        },

        mounted() {
            this.onload();
        },
    };
</script>
